import { render, staticRenderFns } from "./SeriesImageWithoutWireframe.vue?vue&type=template&id=2ec30b1e&"
import script from "./SeriesImageWithoutWireframe.vue?vue&type=script&lang=js&"
export * from "./SeriesImageWithoutWireframe.vue?vue&type=script&lang=js&"
import style0 from "./SeriesImageWithoutWireframe.vue?vue&type=style&index=0&id=2ec30b1e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports